let measureContext: CanvasRenderingContext2D | null = null;

export const getElementFont = (element: Element): string => {
  const { fontStyle, fontWeight, fontSize, fontFamily } =
    getComputedStyle(element);
  return `${fontStyle} ${fontWeight} ${fontSize} ${fontFamily}`;
};

export const measureTextWidth = (text: string, font: string): number => {
  if (!measureContext) {
    measureContext = document.createElement("canvas").getContext("2d");
  }
  if (!measureContext) return 0;
  measureContext.font = font;
  return measureContext.measureText(text).width;
};

export const getFittingText = (
  candidates: string[],
  font: string,
  availableWidth: number,
): string =>
  candidates.find(
    (candidate) => measureTextWidth(candidate, font) <= availableWidth,
  ) ?? "";
